//@ts-check
(function () {
  "use strict";

  //@ts-ignore
  if (window.iconsDotsInited) {
    console.log("Icons dots already initialized.");
    return;
  }
  // Check if the script is running in a browser environment
  const initDots = () => {
    const sliders = document.querySelectorAll("[data-icons-slider]");
    console.log("SLIDERS FOUND: ", sliders);
    sliders.forEach((slider) => {
      const dots = Array.from(
        slider.querySelectorAll(`.slider-dots .slider-dot`)
      );
      const itemsWrapper = slider.querySelector(".grid--slider");
      const items = Array.from(slider.querySelectorAll(".grid__item"));

      if (dots.length === 0 || items.length === 0 || itemsWrapper === null)
        return;

      let currentSlide = 0;

      function updateActiveDot(index) {
        dots.forEach((dot, i) => {
          dot.classList.toggle("active", i === index);
        });
        currentSlide = index;
      }

      function showSlide(index) {
        // Scroll slider to the target position
        const slideWidth = /** @type {HTMLElement} */ (items[0]).offsetWidth;
        console.log("SLIDE WIDTH IS: ", slideWidth);
        const targetScrollLeft = index * slideWidth;

        if (itemsWrapper) {
          /** @type {HTMLElement} */ (itemsWrapper).scrollTo({
            left: targetScrollLeft,
            behavior: "smooth",
          });
        }

        updateActiveDot(index);
      }

      function handleScroll() {
        if (!itemsWrapper) return;

        const slideWidth = /** @type {HTMLElement} */ (items[0]).offsetWidth;
        const scrollLeft = /** @type {HTMLElement} */ (itemsWrapper).scrollLeft;
        const maxScrollLeft =
          /** @type {HTMLElement} */ (itemsWrapper).scrollWidth -
          /** @type {HTMLElement} */ (itemsWrapper).clientWidth;

        // If we're at the very end, show the last slide
        if (scrollLeft >= maxScrollLeft - 5) {
          // 5px tolerance
          const lastIndex = items.length - 1;
          if (lastIndex !== currentSlide) {
            updateActiveDot(lastIndex);
          }
          return;
        }

        // Calculate which slide should be active based on scroll position
        const activeSlideIndex = Math.round(scrollLeft / slideWidth);

        // Ensure index is within bounds
        const boundedIndex = Math.max(
          0,
          Math.min(activeSlideIndex, items.length - 1)
        );

        if (boundedIndex !== currentSlide) {
          updateActiveDot(boundedIndex);
        }
      }

      // Add scroll event listener
      if (itemsWrapper) {
        /** @type {HTMLElement} */ (itemsWrapper).addEventListener(
          "scroll",
          handleScroll
        );
      }

      // Add click events to dots
      dots.forEach((dot, index) => {
        dot.addEventListener("click", () => {
          showSlide(index);
        });
      });

      // Optional: Auto-advance slider
      // setInterval(() => {
      //   currentSlide = (currentSlide + 1) % totalSlides;
      //   showSlide(currentSlide);
      // }, 5000);
    });
  };
  document.addEventListener("DOMContentLoaded", function () {
    initDots();
    //@ts-ignore
    window.iconsDotsInited = true;
  });
})();
